/**
 * PS Collection Grid — sticky "Shop All" button.
 *
 * The button is a zero-height sticky row that sits centred in the section
 * header at rest and pins near the top of the viewport once scrolled past.
 * CSS has no way to express "is currently stuck", so we park a sentinel at the
 * wrapper's natural position and compare the two: when the wrapper has been
 * pushed down relative to the sentinel, it's pinned, and we flag it so the
 * stylesheet can scale the button up.
 *
 * Comparing the two elements — rather than testing the wrapper against a fixed
 * pixel threshold — means this keeps working when the site header reveals on
 * scroll-up and the pin offset grows by the header's height.
 */
(function () {
  'use strict';

  var STUCK_CLASS = 'is-stuck';
  // Sub-pixel rounding means the two rects are never exactly equal at rest.
  var TOLERANCE = 1;

  function init(section) {
    var wrap = section.querySelector('.ps-cg__shop-all-wrap');
    var sentinel = section.querySelector('.ps-cg__shop-all-sentinel');
    if (!wrap || !sentinel) return;

    var queued = false;
    var stuck = false;

    function measure() {
      queued = false;
      var isStuck =
        wrap.getBoundingClientRect().top - sentinel.getBoundingClientRect().top > TOLERANCE;
      if (isStuck === stuck) return;
      stuck = isStuck;
      wrap.classList.toggle(STUCK_CLASS, stuck);
    }

    function schedule() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(measure);
    }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    measure();
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('.ps-cg'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // The theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.ps-cg');
    if (section) init(section);
  });
})();
